// extracted by mini-css-extract-plugin
export default {"debug-icon-container":"hrai2C","debug-icon":"O5SasT","debug-tooltip":"tZvSWC","debug-tooltip-title":"c7tzmt","debug-tooltip-content":"t9_sUd"};